import React from 'react';
import SbEditable from 'storyblok-react';

const Video = ({ blok, className = '', ...other }) => {

  if (!blok?.video?.filename) return null;

  return (
    <SbEditable content={blok}>
      <div className={`${className} ${blok.className || ''} w-full`}>
        <video 
          autoPlay
          muted
          playsInline
          preload="true"
          disablePictureInPicture
          controlsList="nodownload">
          <source src={blok.video.filename} type="video/mp4" />
        </video>
      </div>
    </SbEditable>
  );
};

export default Video;